import React, { forwardRef, useImperativeHandle } from 'react';
import ReCAPTCHA from 'react-google-recaptcha'

const Captcha = forwardRef((props, ref) => {
    // Check if recaptcha is disabled for local development
    const isRecaptchaDisabled = process.env.REACT_APP_DISABLE_RECAPTCHA === 'true';
    const recaptchaRef = React.useRef();

    // If recaptcha is disabled, provide dummy methods through the ref
    useImperativeHandle(ref, () => ({
        getValue: () => {
            if (isRecaptchaDisabled) {
                return 'recaptcha-disabled-dummy-token';
            }
            return recaptchaRef.current?.getValue();
        },
        reset: () => {
            if (!isRecaptchaDisabled && recaptchaRef.current) {
                recaptchaRef.current.reset();
            }
        }
    }));

    if (isRecaptchaDisabled) {
        return <div className="flex"></div>;
    }

    return (
        <div className="flex">
            <ReCAPTCHA 
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_SITE_KEY || '6LdGIZspAAAAAHx84hCssCYpjBPAt3ia7yCVF8qk'}
                {...props}
            />
        </div>
    );
});

export default Captcha;
